<div class="tab-content">
  <!-- Custom tooltip that follows mouse -->
  <div
    *ngIf="tooltipVisible"
    class="custom-contextual-tooltip"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
    role="tooltip">
    {{ tooltipText }}
  </div>
  <div class="container-fluid px-0">
    <!-- Row 1 -->
    <div class="row drink-volume-row kt-margin-b-25">
      <!-- Chart 1: Volume by Drink -->
      <div class="col-md-4 drink-volume-col">
        <div class="chart-card">
          <div class="chart-header">
            <h3>{{ getDrinkVolumeBarChartTitle() }}</h3>
            <div class="chart-controls">
              <div class="chart-metric-toggle" *ngIf="shouldShowBarChartMetricToggle()">
                <button
                  type="button"
                  class="chart-metric-toggle-btn"
                  [class.chart-metric-toggle-btn--active]="chartMetricMode === 'volume'"
                  (click)="setBarChartMetricMode('volume')"
                  title="Show volume">
                  <kt-lucide-icon name="BarChart3" [size]="16"></kt-lucide-icon>
                </button>
                <button
                  type="button"
                  class="chart-metric-toggle-btn"
                  [class.chart-metric-toggle-btn--active]="chartMetricMode === 'revenue'"
                  (click)="setBarChartMetricMode('revenue')"
                  title="Show revenue">
                  <kt-lucide-icon name="DollarSign" [size]="16"></kt-lucide-icon>
                </button>
              </div>
              <button type="button" class="sort-btn" (click)="toggleDrinkVolumeBarChartSort()" [title]="drinkVolumeBarChartSort === 'desc' ? 'Sort ascending' : 'Sort descending'">
                <mat-icon>{{ drinkVolumeBarChartSort === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              </button>
              <button
                *ngIf="shouldShowDrinkVolumeToggle()"
                type="button"
                class="show-all-btn"
                (click)="toggleShowAllDrinkVolumeItems()"
                [title]="getDrinkVolumeToggleTitle()">
                <mat-icon>{{ showAllDrinkVolumeItems ? 'unfold_less' : 'unfold_more' }}</mat-icon>
              </button>
            </div>
          </div>
          <div class="chart-body chart-body-large">
            <div *ngIf="isLoadingDrinkVolume" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingDrinkVolume && hasNoData(drinkVolumeChartDisplayLabels, drinkVolumeChartDisplayData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">insert_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No drink volume data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingDrinkVolume && !hasNoData(drinkVolumeChartDisplayLabels, drinkVolumeChartDisplayData) && drinkVolumeChartDisplayLabels.length > 0 && drinkVolumeChartDisplayData.length > 0">
              <canvas baseChart
                #drinkVolumeBarChart
                [labels]="drinkVolumeChartDisplayLabels"
                [datasets]="drinkVolumeChartDisplayData"
                [options]="drinkVolumeBarChartOptions"
                [colors]="drinkVolumeBarColors"
                [chartType]="'bar'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Data Table -->
      <div class="col-md-4 drink-volume-col">
        <div class="data-card">
          <h3>Drink Volume Data</h3>
          <div class="table-container">
            <div *ngIf="isLoadingDrinkVolume" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingDrinkVolume && !hasFullDrinkVolumeData()" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No drink volume data found for the selected filters</p>
            </div>
            <table class="data-table drink-volume-primary-table" *ngIf="!isLoadingDrinkVolume && hasFullDrinkVolumeData()">
              <thead>
                <tr>
                  <th>{{ getTableFirstColumnHeader() }}</th>
                  <th class="text-right">{{ getTableSecondColumnHeader() }}</th>
                  <th *ngIf="filters.compareEnabled" class="text-right">{{ getTableThirdColumnHeader() }}</th>
                  <th *ngIf="shouldShowRetailRevenueColumns()" class="text-right">{{ getRetailRevenueHeader() }}</th>
                  <th *ngIf="shouldShowRetailRevenueColumns() && filters.compareEnabled" class="text-right">{{ getCompareRetailRevenueHeader() }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of getFullDrinkVolumeLabels(); let i = index">
                  <td [matTooltip]="label.length > 20 ? label : ''" [matTooltipShowDelay]="100">{{ truncateLabel(label) }}</td>
                  <td class="text-right">{{ getFullDrinkVolumeData()[0]?.data[i] || 0 }}</td>
                  <td *ngIf="filters.compareEnabled" class="text-right">{{ getFullDrinkVolumeCompareData()[i] || 0 }}</td>
                  <td *ngIf="shouldShowRetailRevenueColumns()" class="text-right">{{ getRetailRevenueByLabel(label) | currency:'USD':'symbol':'1.2-2' }}</td>
                  <td *ngIf="shouldShowRetailRevenueColumns() && filters.compareEnabled" class="text-right">{{ getCompareRetailRevenueByLabel(label) | currency:'USD':'symbol':'1.2-2' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="font-semibold">Total</td>
                  <td class="text-right font-semibold">
                    {{ getDrinkVolumeBarChartTotal() }}
                  </td>
                  <td *ngIf="filters.compareEnabled" class="text-right font-semibold">
                    {{ getDrinkVolumeCompareTotal() }}
                  </td>
                  <td *ngIf="shouldShowRetailRevenueColumns()" class="text-right font-semibold">
                    {{ drinkVolumeRetailRevenue | currency:'USD':'symbol':'1.2-2' }}
                  </td>
                  <td *ngIf="shouldShowRetailRevenueColumns() && filters.compareEnabled" class="text-right font-semibold">
                    {{ drinkVolumeCompareRetailRevenue | currency:'USD':'symbol':'1.2-2' }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <!-- Donut Chart -->
      <div class="col-md-4 drink-volume-col">
        <div class="chart-card">
          <div class="chart-header">
            <h3>Volume Breakdown by Drink</h3>
          </div>
          <div class="chart-body chart-body-medium">
            <div *ngIf="isLoadingDrinkVolumeBreakdown" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingDrinkVolumeBreakdown && hasNoData(drinkVolumeBreakdownDonutLabels, drinkVolumeBreakdownDonutData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">pie_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No drink breakdown data found for the selected filters</p>
            </div>
            <div class="chart-wrapper">
              <ng-container *ngIf="!isLoadingDrinkVolumeBreakdown && !hasNoData(drinkVolumeBreakdownDonutLabels, drinkVolumeBreakdownDonutData) && breakdownDonutChartKey && drinkVolumeBreakdownDonutLabels.length > 0 && drinkVolumeBreakdownDonutData.length > 0">
                <canvas baseChart
                  #drinkVolumeBreakdownDonutChart
                  [labels]="drinkVolumeBreakdownDonutLabels"
                  [datasets]="drinkVolumeBreakdownDonutData"
                  [options]="breakdownDonutChartOptions"
                  [colors]="donutChartColors"
                  [chartType]="'doughnut'">
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="row drink-volume-row">
      <!-- Volume By Machine (Bar) -->
      <div class="col-md-4 drink-volume-col">
        <div class="chart-card chart-card-medium">
          <div class="chart-header">
            <h3>Volume By Machine</h3>
            <div class="chart-controls">
              <button type="button" class="sort-btn" (click)="toggleMachineDrinkBarChartSort()" [title]="machineDrinkBarChartSort === 'desc' ? 'Sort ascending' : 'Sort descending'">
                <mat-icon>{{ machineDrinkBarChartSort === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              </button>
              <button
                *ngIf="shouldShowMachineDrinkToggle()"
                type="button"
                class="show-all-btn"
                (click)="toggleShowAllMachineDrinkItems()"
                [title]="getMachineDrinkToggleTitle()">
                <mat-icon>{{ showAllMachineDrinkItems ? 'unfold_less' : 'unfold_more' }}</mat-icon>
              </button>
            </div>
          </div>
          <div class="chart-body chart-body-medium">
            <div *ngIf="isLoadingMachineDrinkVolume" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingMachineDrinkVolume && hasNoData(machineDrinkBarLabels, machineDrinkBarData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">insert_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No machine volume data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingMachineDrinkVolume && !hasNoData(machineDrinkBarLabels, machineDrinkBarData) && machineDrinkBarLabels.length > 0 && machineDrinkBarData.length > 0">
              <canvas baseChart
                #machineDrinkBarChart
                [labels]="machineDrinkBarLabels"
                [datasets]="machineDrinkBarData"
                [options]="machineDrinkBarChartOptions"
                [colors]="machineDrinkBarColors"
                [chartType]="'bar'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Machine Drink Volume Data (Table) -->
      <div class="col-md-4 drink-volume-col">
        <div class="data-card">
          <h3>Machine Drink Volume Data</h3>
          <div class="table-container">
            <div *ngIf="isLoadingMachineDrinkVolume" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingMachineDrinkVolume && !hasFullMachineDrinkData()" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No machine volume data found for the selected filters</p>
            </div>
            <table class="data-table" *ngIf="!isLoadingMachineDrinkVolume && hasFullMachineDrinkData()">
              <thead>
                <tr>
                  <th>{{ getTableFirstColumnHeader() }}</th>
                  <th class="text-right">{{ getTableSecondColumnHeader() }}</th>
                  <th *ngIf="filters.compareEnabled" class="text-right">{{ getTableThirdColumnHeader() }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of getFullMachineDrinkLabels(); let i = index">
                  <td [matTooltip]="label.length > 20 ? label : ''" [matTooltipShowDelay]="100">{{ truncateLabel(label) }}</td>
                  <td class="text-right">{{ getFullMachineDrinkData()[0]?.data[i] || 0 }}</td>
                  <td *ngIf="filters.compareEnabled" class="text-right">{{ getFullMachineDrinkCompareData()[i] || 0 }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="font-semibold">Total</td>
                  <td class="text-right font-semibold">
                    {{ getMachineDrinkBarTotal() }}
                  </td>
                  <td *ngIf="filters.compareEnabled" class="text-right font-semibold">
                    {{ getMachineDrinkCompareTotal() }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <!-- Volume Breakdown by Machine (Doughnut) -->
      <div class="col-md-4 drink-volume-col">
        <div class="chart-card chart-card-medium">
          <h3>Volume Breakdown by Machine</h3>
          <div class="chart-body chart-body-medium">
            <div *ngIf="isLoadingMachineBreakdown" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingMachineBreakdown && hasNoData(machineDonutLabels, machineDonutData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">pie_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No machine breakdown data found for the selected filters</p>
            </div>
            <div class="chart-wrapper">
              <ng-container *ngIf="!isLoadingMachineBreakdown && !hasNoData(machineDonutLabels, machineDonutData) && machineDonutChartKey && machineDonutLabels.length > 0 && machineDonutData.length > 0">
                <canvas baseChart
                  #machineDonutChart
                  [labels]="machineDonutLabels"
                  [datasets]="machineDonutData"
                  [options]="machineDonutChartOptions"
                  [colors]="donutChartColors"
                  [chartType]="'doughnut'">
                </canvas>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

